import axios from 'axios';

/**
 * Axios interceptor config to retry a request after getting a new access token.
 */
export default (({
  refreshToken
}) => ({
  success: res => res,
  error: async error => {
    const {
      config
    } = error;
    if (error.response && error.response.status === 401 // Authentication failed for original req
    && config.headers.Authorization // and it included an Authorization header
    && !config._retry // and we haven't already retried
    ) {
      config._retry = true;
      const token = await refreshToken();
      if (!token) {
        return Promise.reject(error);
      }
      config.headers.Authorization = `Bearer ${token}`;
      return axios(config);
    }
    return Promise.reject(error);
  }
}));